import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TokenRefreshService } from '../service/tokenRefreshService';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private myRoute: Router, private tokenRefreshService: TokenRefreshService) {
    // subscribe to refresh results
    this.tokenRefreshService.tokenRefreshed$.subscribe(tokenResponse => {
      localStorage.setItem('PgRestToken', tokenResponse.pgtoken);
      localStorage.setItem('oktaAccessToken', tokenResponse.access_token);
      if (tokenResponse.expires_in) {
        localStorage.setItem('oktaRefreshToken', tokenResponse.refresh_token);
        localStorage.setItem('pg_refresh_token', tokenResponse.PgRefreshToken);
        this.scheduleTokenRefresh(tokenResponse.refresh_token, tokenResponse.expires_in);
      }
    });

    // subscribe to refresh errors
    this.tokenRefreshService.refreshError$.subscribe(err => {
      console.error('Refresh failed, logging out', err);
      this.logout();
    });
  }

  sendToken(token: string, usertype, PgRestToken?: string, oktaaccess_token?: string) {
    localStorage.setItem('LoggedIn', 'true');
    localStorage.setItem("LoggedInUser", token)
    localStorage.setItem("LoggedInUserType", usertype);
    localStorage.setItem("PgRestToken", PgRestToken);
    localStorage.setItem('oktaAccessToken', oktaaccess_token);
  }
  getToken() {
    return localStorage.getItem("LoggedInUser")
  }
  getType() {
    return localStorage.getItem("LoggedInUserType")
  }
  isLoggednIn() {
    return (this.getToken() && this.getType()) !== null;
  }
  logout() {

    this.stopTokenRefresh();
    // Get the ID token from localStorage
    const idToken = localStorage.getItem('oktaIdToken');
    let currentEnvEndpoint = sessionStorage.getItem('envEndpoint');
    // Build the logout URL with environment variables
    const logoutUrl = `${environment.oktaConfig.oktaLogoutUrl[currentEnvEndpoint]}?id_token_hint=${idToken || ''}&post_logout_redirect_uri=${environment.oktaConfig.postLogoutRedirectUri[currentEnvEndpoint]}`;

    // Redirect to Okta logout URL
    window.location.href = logoutUrl;
    localStorage.removeItem("LoggedInUser");
    localStorage.removeItem("LoggedInUserType");
    localStorage.removeItem("activeMenu");
    localStorage.removeItem("PgRestToken");
    localStorage.removeItem("oktaAccessToken");
    localStorage.removeItem("oktaRefreshToken");
    localStorage.removeItem("oktaIdToken");
    localStorage.removeItem("pg_refresh_token");
    localStorage.setItem('LoggedIn', 'false');
    this.myRoute.navigate([""]);
  }

  scheduleTokenRefresh(refreshToken: string, expiresIn: number) {
    this.tokenRefreshService.scheduleTokenRefresh(refreshToken, expiresIn);
  }

  stopTokenRefresh() {
    this.tokenRefreshService.stopTokenRefresh();
  }
}
